import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { ServiceDataPickerComponent } from './service-data-picker.component';

@NgModule({
  declarations: [
    ServiceDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    ServiceDataPickerComponent
  ]
})
export class ServiceDataPickerModule { }
